
import React,{useState, Component, useEffect} from 'react';
import { AuthUserContext } from '../components/Session'
import { withFirebase } from '../components/Firebase';

import { Nav, Navbar, NavDropdown, Form, FormControl, Button, NavItem, Modal, Card, CardDeck,ButtonGroup, Row as Row, Col } from 'react-bootstrap'

import { faGlobe,faFlag, faPhoneSquare} from "@fortawesome/free-solid-svg-icons";
import { faLine, faFacebookSquare, faInstagramSquare, faTwitterSquare, faYoutube,  } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import {Pie, Bar, Line, HorizontalBar} from 'react-chartjs-2';
// #####################        Source (pie)        #####################
const data = {
	labels: [
		'Youtube',
		'Facebook',
		'Other'
	],
	datasets: [{
    label: 'จำนวนโพสที่ไม่เหมาะสม',
		data: [24756, 12320, 3093],
		backgroundColor: [
		'#F00',
		'#3B5998',
		'#FFCE56'
		],
		hoverBackgroundColor: [
		'#F00',
		'#3B5998',
		'#FFCE56'
		]
	}]
};
const option = {
  legend: { 
    position: 'bottom' 
  },
  tooltips: {
    // responsive: true,
    //         legend: {
    //             position: 'bottom',
    //             display: true,
 
    //         },
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  }
}
// #####################        Source per year (line)        #####################
const data_source_per_year = {
	labels: ['ปี 2559', 'ปี 2560', 'ปี 2561', 'ปี 2562', 'ปี 2563'],
	datasets: [{
    label: 'จำนวนโพสที่ไม่เหมาะสม',
    data: [24756, 12320, 3093],
		backgroundColor: [
		'#3B5998',
		'#3B5998',
		'#3B5998'
		],
		hoverBackgroundColor: [
		'#F00',
		'#F00',
		'#F00'
    ],
    data: [5351, 11042, 13908, 5777, 4082],
      backgroundColor: "#4082c4"
	}]
};
const option_source_per_year = {
  responsive: true,
            legend: {
                position: 'bottom',
                display: true,
 
            },
            "hover": {
              "animationDuration": 0
            },
             "animation": {
                "duration": 1,
              "onComplete": function() {
                var chartInstance = this.chart,
                  ctx = chartInstance.ctx;
 
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
 
                this.data.datasets.forEach(function(dataset, i) {
                  var meta = chartInstance.controller.getDatasetMeta(i);
                  meta.data.forEach(function(bar, index) {
                    var data = dataset.data[index];
                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                  });
                });
              }
            },
            title: {
                display: false,
                text: ''
            },
  scales: { 
      yAxes: [{
          ticks: {
            max: Math.max(...data.datasets[0].data) + 10,
            beginAtZero: true
          }
      }]
  }
}

// #####################        Source per year (bar)        #####################

const dataLine = {
  labels: ['ปี 2559', 'ปี 2560', 'ปี 2561', 'ปี 2562', 'ปี 2563'],
  datasets: [
    {
      label: 'จำนวนโพสที่ไม่เหมาะสม',
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [5351, 11042, 13908, 5777, 4082],
      backgroundColor: "#4082c4"
    }
  ]
};
const optionLine = {
  "hover": {
    "animationDuration": 0
  },
  "animation": {
    "duration": 1,
    "onComplete": function() {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;

      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fontStyle = "bold";
      ctx.fillStyle = "#FF0000";

      this.data.datasets.forEach(function(dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function(bar, index) {
          var data = dataset.data[index];
          ctx.fillText(data, bar._model.x, bar._model.y - 5);
        });
      });
    }
  },
  scales: { 
      yAxes: [{
          ticks: {
            max: Math.max(...data.datasets[0].data) + 10,
            beginAtZero: true
          }
      }]
  }
}

// #####################        Poster by Source (Ho Bar)        #####################


const data_poster_by_source_youtube = {
  labels: [
    "HaunT89s","สหพันธรัฐไ","sanamluang","ชาวนา","สหพันธรัฐไ","สหพันธรัฐไ","FAIYEN CHA","TRUTH CHAN","77LL","thai silen","Thai Democ","เสรีภาพ สห","YAMMY CHAN","เพื่อประชา","กูมาไกล กู","สหพันธรัฐไ","Thai Proto","สหพันธรัฐ ","Nong May","สหพันธรัฐไ"
  ],
  datasets: [
    {
      label: 'จำนวนโพส',
      backgroundColor: '#FF0000',
      borderColor: '#FF0000',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [
        1684,1003,792,727,682,516,467,453,415,363,344,297,293,279,263,231,227,209,197,197
      ]
    }
  ]
};
const data_poster_by_source_facebook = {
  labels: [
    "Trairong S","Nin Berger","Suda Rangk","Junya Yimp","Pavin Chac","นางแมวจอมว","ป้าหนิง ดี","ป้าหนิง DK","Andrew Mac","องศ์หญิงถั","Sanan Karn","วงไฟเย็น","Chaiwat En","Somsak Jea","ป้าหนิง ดี","นางแมวจอมว","รมย์ชลี สิ","ลุงสมชาย ป","Boonheng H","Mona Nilss"
  ],
  datasets: [
    {
      label: 'จำนวนโพส',
      backgroundColor: '#3b5998',
      borderColor: '#3b5998',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [
        567,474,346,279,259,253,251,212,191,142,125,122,94,94,90,86,86,71,70,70
      ]
    }
  ]
};
const data_poster_by_source_other = {
  labels: [
    "HaunT89s","-","Thai Democ","sanamluang","thai silen","Trairong S","Thai Democ","FAIYEN CHA","ป้าหนิง ดี","Media Forc","หลวง ไทย","Thai Proto","นางแมวจอมว","รัฐส้มโอหว","Thai Democ","YAMMY CHAN","รมย์ชลี สิ","วงไฟเย็น","PeaceVoice","Thai Kumnu"
  ],
  datasets: [
    {
      label: 'จำนวนโพส',
      backgroundColor: '#1DA1F2',
      borderColor: '#1DA1F2',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: [
        1556,498,461,410,382,372,357,328,301,282,258,243,213,209,196,192,172,166,157,145
      ]
    }
  ]
};
const option_poster_by_source_youtube = {
  "hover": {
    "animationDuration": 0
  },
  "animation": {
    "duration": 1,
    "onComplete": function() {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;

      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fontStyle = "bold";
      ctx.fillStyle = "#0000FF";

      this.data.datasets.forEach(function(dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function(bar, index) {
          var data = dataset.data[index];
          ctx.fillText(data, bar._model.x + 10, bar._model.y + 5);
        });
      });
    }
  },
  scales: { 
      yAxes: [{
          ticks: {
            max: Math.max(...data_poster_by_source_youtube.datasets[0].data) + 10,
            beginAtZero: true
          }
      }],
      xAxes: [{
        ticks: {
          max: Math.max(...data_poster_by_source_youtube.datasets[0].data) + 10,
          beginAtZero: true
        }
    }]
  }
}
const option_poster_by_source_facebook = {
  "hover": {
    "animationDuration": 0
  },
  "animation": {
    "duration": 1,
    "onComplete": function() {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;

      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fontStyle = "bold";
      ctx.fillStyle = "#0000FF";

      this.data.datasets.forEach(function(dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function(bar, index) {
          var data = dataset.data[index];
          ctx.fillText(data, bar._model.x + 10, bar._model.y + 5);
        });
      });
    }
  },
  scales: { 
      yAxes: [{
          ticks: {
            max: Math.max(...data_poster_by_source_facebook.datasets[0].data) + 10,
            beginAtZero: true
          }
      }],
      xAxes: [{
        ticks: {
          max: Math.max(...data_poster_by_source_facebook.datasets[0].data) + 10,
          beginAtZero: true
        }
    }]
  }
}
const option_poster_by_source_other = {
  "hover": {
    "animationDuration": 0
  },
  "animation": {
    "duration": 1,
    "onComplete": function() {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;

      ctx.textAlign = 'center';
      ctx.textBaseline = 'bottom';
      ctx.fontStyle = "bold";
      ctx.fillStyle = "#0000FF";

      this.data.datasets.forEach(function(dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function(bar, index) {
          var data = dataset.data[index];
          ctx.fillText(data, bar._model.x + 10, bar._model.y + 5);
        });
      });
    }
  },
  scales: { 
      yAxes: [{
          ticks: {
            max: Math.max(...data_poster_by_source_facebook.datasets[0].data) + 10,
            beginAtZero: true
          }
      }],
      xAxes: [{
        ticks: {
          max: Math.max(...data_poster_by_source_facebook.datasets[0].data) + 10,
          beginAtZero: true
        }
    }]
  }
}






const PageFunction = (props) => {
  const firebase = props.firebase;
  const firestore = props.firebase.firestore;
  const db = props.firebase.firestore;
  const collection = db.collection("website");
  
  const [websiteList, setWebsiteList] = useState([]);
  const [websiteCreate, setWebsiteCreate] = useState({startDate:new Date()})
  const [websiteUpdate, setWebsiteUpdate] = useState({});
  const [master, setMaster] = useState({});
  const masterList = ["m1","m2"];

  React.useEffect(()=>{
    // const fetchData = async () =>{ getCol(firebase,setWebsiteList,"website") }
    // fetchData(0);
  },[]);
  
  // const onCreate = async ()=>{ 
  // };
  // const onDelete = (id)=>{ collection.doc(id).delete(); }
  // const onUpdate = (id)=>{ collection.doc(id).set({...websiteUpdate,createDate: firebase.firestore.FieldValue.serverTimestamp()}); }
  // const websiteCreateChange = (key,value) => { console.log("Create("+key+","+value+")"); setWebsiteCreate({ ...websiteCreate, [key]: value }); }
  // const websiteUpdateChange = (key, value, index) => { console.log("Update("+key+","+value+","+index+")"); const temp = websiteList[index];temp[key] = value; setWebsiteUpdate(temp); }

  return (
  <div className="App">
    <div>




      <br/>
      <div className="c-content-box c-size-md c-overflow-hide c-bs-grid-small-space c-bg-grey-1" >
        <div className="container">
            <div className="c-content-bar-1 c-opt-1">
                <h3 className="c-font-uppercase c-font-bold ">อันดับผู้โพสเนื้อหาที่ไม่เหมาะสม (ตามแหล่งที่มา)</h3>
                <p className="c-font-uppercase">
                </p>
            </div>
        </div> 
      </div>
      <br/>
      <Row>
        <Col>
        <Card>
            <Card.Body>
            <Card.Title> <FontAwesomeIcon size="6x" style={{textAlign:"center"}} color="#FF0000" icon={faYoutube}/></Card.Title>
              <Card.Title>Youtube</Card.Title>
              <Card.Text>
                24,756 Post
              </Card.Text>
            </Card.Body>
          </Card>
          <HorizontalBar height="400px" data={data_poster_by_source_youtube} options={option_poster_by_source_youtube} />
        </Col>
        <Col>
          <Card>
            <Card.Body>
            <Card.Title> <FontAwesomeIcon size="6x" style={{textAlign:"center"}} color="#3b5998" icon={faFacebookSquare}/></Card.Title>
              <Card.Title>Facebook</Card.Title>
              <Card.Text>
                12,320 Post
              </Card.Text>
            </Card.Body>
          </Card>
          <HorizontalBar height="400px" data={data_poster_by_source_facebook} options={option_poster_by_source_facebook} />
        </Col>
        <Col>
          <Card>
            <Card.Body>
            <Card.Title> <FontAwesomeIcon size="6x" style={{textAlign:"center"}} color="#1DA1F2" icon={faGlobe}/></Card.Title>
              <Card.Title>Other</Card.Title>
              <Card.Text>
                3,093 Post
              </Card.Text>
            </Card.Body>
          </Card>
          <HorizontalBar height="400px" data={data_poster_by_source_other} options={option_poster_by_source_other} />
        </Col>
      </Row>
      
        
      </div>
      <br/>
      
      <br/>
      


  </div>
  );
}

class Page extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <PageFunction firebase={this.props.firebase} />
    );
  }
}

export default withFirebase(Page);